import type { PropsWithChildren } from 'react'

import { authUri } from '@fv/client-core'

import LoadingPage from '@/components/layout/LoadingPage'
import { useAdminContext } from '@/hooks/useAdminContext'

// Here we will manage site-wide data like user context and active opportunities.
const SiteProvider = ({ children }: PropsWithChildren) => {
  const contextQuery = useAdminContext()

  if ((contextQuery.error as any)?.status === 401) {
    window.location.href = `${authUri}/signin/admin?redirect=${encodeURIComponent(window.location.toString())}`
  }

  if (!contextQuery.data) return <LoadingPage />

  return children
}

// biome-ignore lint/style/noDefaultExport: lazy
export default SiteProvider
